import { toast } from "react-toastify";
import Formatmessage from "./Formatmessage";

export const handleFileUpload = async (
  file,
  bucketName = "school_images",
  uploadmedia
) => {
  if (!file) return false;

  const formData = new FormData();
  formData.append("media", file);
  formData.append("bucket_name", bucketName);

  try {
    const response = await uploadmedia(formData).unwrap();

    if (response?.status === 1) {
      return { success: true, imageUrl: response?.imageUrl };
    } else {
      toast.error(Formatmessage(response?.message) || "Upload image failed");
      return { success: false, imageUrl: "" };
    }
  } catch (error) {
    toast.error("Internal server error");
    console.error("Upload error:", error);
    return false;
  }
};
